import type { ShapeText } from "../types";

/**
 * Rotation (degrés, sens horaire depuis le nord) d'un texte posé au sol : la sienne, sinon celle du
 * texte normal (dont hérite le texte au survol), sinon `defaultRotationDeg`. Aucune s'il reste à l'endroit.
 */
export function shapeTextRotationDeg(
  text: ShapeText | undefined,
  normalText: ShapeText | undefined,
  upright: boolean,
  defaultRotationDeg: number,
): number {
  if (upright) return 0;

  return text?.rotation ?? normalText?.rotation ?? defaultRotationDeg;
}

/** Vrai quand un texte posé au sol à `rotationDeg` se montre à l'envers sous une carte orientée à `bearingDeg`. */
export function isTextUpsideDown(rotationDeg: number, bearingDeg: number): boolean {
  const onScreen = ((((rotationDeg - bearingDeg) % 360) + 540) % 360) - 180;
  return onScreen > 90 || onScreen <= -90;
}

/** Cap (0–360) de la vue de départ : l'opposé de sa `rotationDeg` (voir `showStartView`). */
export function startViewBearingDeg(startRotationDeg: number): number {
  return (((-startRotationDeg) % 360) + 360) % 360;
}
